export default "__VITE_ASSET__DizVKR2S__"